var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14C14.7614 14 17 11.7614 17 9C17 6.23858 14.7614 4 12 4ZM9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9Z",
    fill: "#3B5118"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 15C8.83181 15 6.00184 16.4494 4.13739 18.7179C3.87439 19.0379 3.95723 19.5079 4.29569 19.7467L4.70424 20.035C5.04269 20.2738 5.50817 20.1903 5.77681 19.8751C7.2771 18.1143 9.50865 17 12.0004 17C14.4917 17 16.7228 18.1139 18.2231 19.8741C18.4918 20.1893 18.9573 20.2726 19.2957 20.0338L19.7042 19.7455C20.0426 19.5066 20.1254 19.0366 19.8623 18.7167C17.9979 16.4489 15.1684 15 12.0004 15Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconprofile);
export default __webpack_public_path__ + "static/media/icon.profile.dcea6201399237c4918b3da21a8c0cbb.svg";
export { ForwardRef as ReactComponent };